module.exports = __webpack_public_path__ + "static/img/systemDesign.0323ba07.png";